<template>
  <div class="activities-container">
    <v-layout row wrap>
      <v-flex align-content-space-between
              md4
              xs12
              v-if="paymentTrue !== undefined && paymentTrue !== null && paymentTrue.length > 0"
              v-for="inventory in paymentTrue"
              :key="inventory.public_id">
        <v-container fluid class="pa-2">
          <v-card flat hover class="activity-card elevation-2">
            <!-- Image section - clickable to open info -->
            <div @click="openInfo(inventory)" style="cursor: pointer;">
              <v-img class="activity-image"
                     :src="inventory.thumbnail"
                     aspect-ratio="1.5"
                     gradient="to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.3)">
                <v-container fill-height class="pa-0">
                  <v-layout align-end class="image-overlay">
                    <v-flex xs12>
                      <span class="activity-badge" v-if="inventory.pricing_status === 'true'">
                        From {{$localCurrency}} {{$roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount)}}
                      </span>
                      <span class="activity-note" v-if="inventory.note">
                        {{inventory.note}}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </div>

            <v-container fluid class="pt-3 pb-0">
              <!-- Title section - clickable to open info -->
              <div @click="openInfo(inventory)" style="cursor: pointer; display: inline-block;">
                <h3 class="activity-title earthwerk-font">{{(inventory.name).toUpperCase()}}</h3>
              </div>

              <!-- Info icon -->
              <v-icon small @click="openInfo(inventory)" class="info-icon">info_outline</v-icon>

              <div class="activity-details mt-2">
                <span v-if="inventory.pricing_status === 'true'">
                  <div v-if="inventory.ranger_marker === false" class="price-info">
                    <div class="price-pack">
                      <span>Child: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(inventory.price.currency_type, inventory.price.child_price).amount)}}</span>
                    </div>
                    <div class="price-pack">
                      <span>Adult: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount)}}</span>
                    </div>
                  </div>
                  <div v-else class="price-info">
                    <div class="price-pack">
                      <span>Ranger Price: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount)}}</span>
                    </div>
                  </div>
                </span>
                <span v-else class="pricing-text">
                  {{inventory.pricing}}
                </span>
              </div>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="paymentTrue === undefined || paymentTrue === null || paymentTrue.length === 0">
      <v-flex lg4 md12 xs12 sm12 v-for="n in 3" :key="n">
        <v-container fluid class="pa-2">
          <v-card class="elevation-2">
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Info Dialog -->
    <v-dialog v-model="infoDialog" persistent max-width="900px">
      <v-card class="info-dialog">
        <div class="gallery-section">
          <div v-if="infoImages && infoImages.length > 0" class="gallery-container">
            <div class="image-navigation">
              <button class="nav-button prev" @click="prevInfoImage" :disabled="currentInfoImageIndex === 0">
                <v-icon>chevron_left</v-icon>
              </button>
              <div class="image-wrapper">
                <img :src="infoImages[currentInfoImageIndex].path" class="gallery-image" alt="Activity image">
              </div>
              <button class="nav-button next" @click="nextInfoImage" :disabled="currentInfoImageIndex === infoImages.length - 1">
                <v-icon>chevron_right</v-icon>
              </button>
            </div>
            <div class="image-counter">
              {{ currentInfoImageIndex + 1 }} / {{ infoImages.length }}
            </div>
          </div>
          <div v-else class="single-image-container">
            <img :src="currentInfoActivity ? currentInfoActivity.thumbnail : ''" class="gallery-image" alt="Activity thumbnail">
          </div>
        </div>
        
        <v-card-text class="details-section">
          <div class="details-header">
            <h1 class="activity-title earthwerk-font">{{ currentInfoActivity ? currentInfoActivity.name.toUpperCase() : '' }}</h1>
          </div>
          <div class="description-section" v-html="currentInfoActivity ? currentInfoActivity.description : ''"></div>
        </v-card-text>
        
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="infoDialog = false" class="earthwerk-font">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ActivitiesGrid',
    data() {
      return {
        infoDialog: false,
        currentInfoActivity: null,
        currentInfoImageIndex: 0,
        infoImages: []
      }
    },
    created() {
      this.$store.dispatch('get_public_active_activities')
    },
    computed: {
      paymentTrue: function () {
        var activeInventory = []
        if (this.activeInventory && Array.isArray(this.activeInventory)) {
          this.activeInventory.map(function (data) {
            if (data.pricing_status === 'true' && data.thumbnail !== null) {
              activeInventory.push(data)
            }
          })
        }
        return activeInventory
      }
    },
    methods: {
      openInfo(activity) {
        this.currentInfoActivity = activity
        this.currentInfoImageIndex = 0
        this.infoDialog = true
        
        if (this.$store.dispatch && this.$store._actions && this.$store._actions['get_facility_images']) {
          this.$store.dispatch('get_facility_images', activity.public_id).then(() => {
            if (this.$store.state.FacilityStore && this.$store.state.FacilityStore.facility_images) {
              this.infoImages = this.$store.state.FacilityStore.facility_images
            }
          }).catch(() => {
            this.infoImages = []
          })
        }
      },
      
      prevInfoImage() {
        if (this.currentInfoImageIndex > 0) {
          this.currentInfoImageIndex--
        }
      },
      
      nextInfoImage() {
        if (this.currentInfoImageIndex < this.infoImages.length - 1) {
          this.currentInfoImageIndex++
        }
      },
      
      inventoryImage: function (image) {
        return 'http://192.168.3.194:8080/var/www/html/opc_services/' + image
      },
      
      getInventoryUrl: function (image) {
        return 'http://178.79.164.219:8000/var/www/html/opc_services/' + image
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('../PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  .activities-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .activity-card {
    border-radius: 8px !important;
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .activity-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
  }

  .activity-image {
    border-radius: 8px 8px 0 0 !important;
    transition: transform 0.5s ease;
    overflow: hidden;
  }

  .activity-card:hover .activity-image {
    transform: scale(1.05);
  }

  .image-overlay {
    padding: 16px;
  }

  .activity-badge {
    background-color: rgba(116, 165, 51, 0.9);
    color: white;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
    margin-bottom: 8px;
  }

  .activity-note {
    background-color: rgba(52, 152, 219, 0.9);
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    display: block;
    max-width: 100%;
    position: relative;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    line-height: 1.4;
    margin-top: 8px;
    border-left: 3px solid rgba(255,255,255,0.5);
    animation: fadeIn 0.5s ease;
  }

  .activity-note::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 15px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgba(52, 152, 219, 0.9);
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 20px;
    line-height: 1.3;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  .activity-title {
    transition: color 0.2s ease;
    display: inline-block;
  }

  .activity-title:hover {
    color: #74a533 !important;
  }

  .info-icon {
    cursor: pointer;
    color: #666;
    margin-left: 10px;
    vertical-align: middle;
    transition: color 0.2s ease;
  }

  .info-icon:hover {
    color: #74a533;
  }

  .price-info {
    color: #666;
    font-size: 14px;
  }

  .price-pack {
    margin-bottom: 6px;
  }

  .price-pack span:last-child {
    color: #e67e22;
    font-weight: 600;
  }

  .pricing-text {
    color: #666;
    font-size: 14px;
  }

  .activity-details {
    border-top: 1px solid #eee;
    padding-top: 12px;
  }

  /* Dialog Styles */
  .info-dialog {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .gallery-section {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .gallery-container, .single-image-container {
    width: 100%;
    height: 400px;
  }

  .image-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    position: relative;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .nav-button:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  .nav-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .nav-button.prev {
    left: 20px;
  }

  .nav-button.next {
    right: 20px;
  }

  .image-counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10;
  }

  .details-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .details-header {
    margin-bottom: 25px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  .description-section {
    color: #555;
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 960px) {
    .earthwerk-font {
      font-size: 18px;
    }
    
    .gallery-container, .single-image-container {
      height: 300px;
    }
  }

  @media (max-width: 600px) {
    .activity-card {
      margin-bottom: 16px;
    }

    .earthwerk-font {
      font-size: 16px;
    }

    .activity-note {
      font-size: 12px;
      padding: 4px 8px;
    }
    
    .gallery-container, .single-image-container {
      height: 250px;
    }
    
    .nav-button {
      width: 35px;
      height: 35px;
    }
    
    .nav-button.prev {
      left: 10px;
    }
    
    .nav-button.next {
      right: 10px;
    }
  }
</style>